
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import ScrollToTop from './Components/ScrollToTop';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import Articles from './Pages/Articles';
import Newsletter from './Pages/Newsletter';
import Podcast from './Pages/Podcast';
import NewSignUp from './Pages/NewSignUp';
import Login from './Pages/Login';
import Signup from './Pages/Signup';
import ArticleReadMore from './Pages/ArticleReadMore';
import UserProfile from './Pages/UserProfile';
import Profile from './Pages/Profile';
import Privacy from './Pages/Privacy';


export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/articles/:id" element={<ArticleReadMore />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/NewSignUp" element={<NewSignUp />} />
            <Route path="/UserProfile" element={<UserProfile />} />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/privacy" element={<Privacy />} />
            
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}